import Vue from 'vue'
import { HTTP } from '../../../../utils/httpCommonUtil'
import { BallPulseLoader } from 'vue-loaders';
import VueSimpleSpinner from 'vue-simple-spinner'
import { getRestParamErrorMessage, getRestResponseErrorMessage } from '@/utils/serverErrorMessageUtil';
import flatPickr from 'vue-flatpickr-component';
import { UserRoleEnum } from '@/enums/userRolesEnum'
import GenericModal from '@/componentsReusable/genericModal.vue'
import facilityEventHub from '@/components/facility/FacilityEventHub';

export default Vue.component('facility-specialty-contacts-card', {
  name: 'FacilitySpecialtyContactCard',
  data () {
    return {
      cardExpanded: false,
      loadingInitialData: false,
      savingNewFacilitySpecialtyContact: false,
      facilitySpecialtyContacts: [],
      isAuthorizedToDelete: false,
      showConfirmationModal: false,
      showDeleteSpecialtyConfirmationModal: false,
      pendingDeleteFacilitySpecialtyContact: null,
      systemContactTypes: []
    }
  },
  components: {
    BallPulseLoader,
    VueSimpleSpinner,
    GenericModal,
    flatPickr
  },
  beforeMount: function () {
    this.isAuthorizedToDelete = this.$store.getters['user/hasRole']([UserRoleEnum.MANAGER]);
  },
  created: function () {
    facilityEventHub.$on('SPECIALTY_CHANGE', this.specialtyChangeEvent)
    facilityEventHub.$on('SPECIALTY_CONTACT_CHANGE', this.specialtyContactChangeEvent)
  },
  beforeDestroy: function () {
    facilityEventHub.$off('SPECIALTY_CHANGE', this.specialtyChangeEvent)
    facilityEventHub.$off('SPECIALTY_CONTACT_CHANGE', this.specialtyContactChangeEvent)
  },
  filters: {
    phoneNumber (phoneNumber: string) {
      let formattedPhoneNumber = phoneNumber;
      if (phoneNumber && phoneNumber.length) {
        let phoneNumberArray = phoneNumber.match(/(\d)?(\d\d\d)?(\d\d\d)(\d\d\d\d)$/);
        if (!phoneNumberArray) { return formattedPhoneNumber; }
        formattedPhoneNumber = phoneNumberArray.length ? '' : formattedPhoneNumber;
        for (let i = 1; i < phoneNumberArray.length; i++) {
          if (phoneNumberArray[i]) {
            formattedPhoneNumber += phoneNumberArray[i] + '.';
          }
        }
        formattedPhoneNumber = formattedPhoneNumber.slice(0,formattedPhoneNumber.length - 1);
      } else {
        formattedPhoneNumber = 'NA';
      }
      return formattedPhoneNumber;
    }
  },
  methods: {
    specialtyChangeEvent () {
      setTimeout( () => {
        this.getFacilitySpecialtyContacts();
        this.getSystemContactTypes();
      },0);
    },
    specialtyContactChangeEvent () {
      // Refresh the Facility Specialty Contacts.
      this.getFacilitySpecialtyContacts();
    },
    expandCard () {
      this.cardExpanded = !this.cardExpanded;
      if (this.cardExpanded) {
        this.getFacilitySpecialtyContacts();
        this.getSystemContactTypes();
      }
    },
    getSystemContactTypes () {
      let self = this
      let showLoadingSpinnerTimeout = setTimeout(function () {
        self.loadingInitialData = true;
      }, 500);
      HTTP.get('/api/facility-contact-types')
      .then(function (response) {
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        if (!response.data || !response.data.data) {
          throw new Error("Error retrieving Contact Types.");
        }
        self.systemContactTypes = response.data.data;
      })
      .catch(function () {
        console.log('response Error!');
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred retrieving System Contact Types.'
        });
      })
    },
    getFacilitySpecialtyContacts () {
      let self = this;
      let showLoadingSpinnerTimeout = setTimeout(function () {
        self.loadingInitialData = true;
      }, 0);
      HTTP.get('/api/facilities/' + this.$route.params.facilityId + '/specialties/' + this.$route.params.specialtyId + '/contacts')
      .then(function (response) {
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        if (!response.data || !response.data.data) {
          throw new Error("Error retrieving Provider Facility Specialty Contacts.");
        }
        let freshFacilitySpecialtyContacts = response.data.data;
        freshFacilitySpecialtyContacts.forEach( function (facilitySpecialtyContact: any) {
          facilitySpecialtyContact.isEditing = false;
          facilitySpecialtyContact.isNew = false;
          facilitySpecialtyContact.updatingData = false;
        });

        self.facilitySpecialtyContacts = freshFacilitySpecialtyContacts;
      })
      .catch(function (err) {
        console.log('response Error!');
        console.log(err);
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred retrieving Facility Specialty Contacts.'
        });
      })
    },
    facilitySpecialtyContactTypeChange (facilitySpecialtyContact: any) {
      console.log(facilitySpecialtyContact);
      this.systemContactTypes.forEach(function (contactType: any) {
        if (facilitySpecialtyContact.facilityContactTypeId === contactType.id) {
          facilitySpecialtyContact.facilityContactTypeName = contactType.name;
        }
      });
      // facilitySpecialtyContact.isAvailable = facilitySpecialtyContact.isAvailableString === 'true' ? true : false;
    },
    // saveFacilitySpecialtyContact (newFacilitySpecialtyContact: any) {
    //   let self = this
    //   self.savingNewFacilitySpecialtyContact = true;
    //   // newFacilitySpecialtyContact.isWelcomed = newFacilitySpecialtyContact.isWelcomed === 'true' ? true : false;
    //   HTTP.post('/api/providers/' + this.$route.params.providerId + '/facility-specialty-contacts', newFacilitySpecialtyContact)
    //   .then(function (response) {
    //     self.savingNewFacilitySpecialtyContact = false;
    //     newFacilitySpecialtyContact.isEditing = false;
    //     self.getFacilitySpecialtyContacts();
    //   })
    //   .catch(function (error) {
    //     self.savingNewFacilitySpecialtyContact = false;

    //     // newFacilitySpecialtyContact.idErrorMessage = getRestParamErrorMessage(error, 'id');
    //     newFacilitySpecialtyContact.isAvailableErrorMessage = getRestParamErrorMessage(error, 'isAvailable');
    //     newFacilitySpecialtyContact.startDateErrorMessage = getRestParamErrorMessage(error, 'startDate');
    //     newFacilitySpecialtyContact.endDateErrorMessage = getRestParamErrorMessage(error, 'endDate');
    //     newFacilitySpecialtyContact.noteErrorMessage = getRestParamErrorMessage(error, 'note');

    //     if (
    //       !newFacilitySpecialtyContact.isAvailableErrorMessage.length &&
    //       !newFacilitySpecialtyContact.startDateErrorMessage.length &&
    //       !newFacilitySpecialtyContact.endDateErrorMessage.length &&
    //       !newFacilitySpecialtyContact.noteErrorMessage.length
    //     ) {
    //       let generalError = getRestResponseErrorMessage(error);
    //       self.$notify({
    //         group: 'main',
    //         type: 'error',
    //         title: 'Error Saving',
    //         text: generalError ? generalError : 'An error occurred saving facilitySpecialtyContact.',
    //         // duration: 5000
    //       });
    //     }

    //   })
    // },

    updateFacilitySpecialtyContact (updatedSpecialty: any) {
      let self = this;

      updatedSpecialty.specialtyIdErrorMessage = null;
      updatedSpecialty.facilityContactTypeIdErrorMessage = null;

      updatedSpecialty.updatingData = true;
      HTTP.put('/api/facilities/' + updatedSpecialty.facilityId + '/contacts/' + updatedSpecialty.facilityContactId + '/specialties', updatedSpecialty)
      .then(function (response) {
        updatedSpecialty.updatingData = false;
        updatedSpecialty.isEditing = false;

        // Broadcast, to whoever is listening, that a new Facility Contact Specialty has been saved
        facilityEventHub.$emit('SPECIALTY_CONTACT_CHANGE');

        self.$notify({
          group: 'main',
          type: 'success',
          title: 'Successfully Updated',
          text: 'Successfully updated Facility Contact Specialty.',
          // duration: 5000
        });
      })
      .catch(function (error) {
        updatedSpecialty.updatingData = false;

        updatedSpecialty.specialtyIdErrorMessage = getRestParamErrorMessage(error,'specialtyId');
        updatedSpecialty.facilityContactTypeIdErrorMessage = getRestParamErrorMessage(error,'facilityContactTypeId');

        if (
          !updatedSpecialty.specialtyIdErrorMessage.length &&
          !updatedSpecialty.facilityContactTypeIdErrorMessage.length
        ) {
          let generalError = getRestResponseErrorMessage(error);
          self.$notify({
            group: 'main',
            type: 'error',
            title: 'Error Updating',
            text: generalError ? generalError : 'An error occurred updating facility contact specialty.',
            // duration: 5000
          });
        }

      })
    },
    deleteSpecialtyConfirmed (deleteContact: any) {
      this.showDeleteSpecialtyConfirmationModal = false;
      this.deleteFacilitySpecialtyContact((this as any).pendingDeleteSpecialty, true, (this as any).pendingFacilityContact);
    },
    deleteFacilitySpecialtyContact (deleteSpecialty: any, bypassDeleteConfirmation: boolean = false, facilityContact: any) {
      // To prevent a double submit
      if (deleteSpecialty.updatingData) { console.log("returning."); return ; }

      if (!bypassDeleteConfirmation) {
        // Show Delete Confirmation Modal
        this.showDeleteSpecialtyConfirmationModal = true;
        (this as any).pendingDeleteSpecialty = deleteSpecialty;
        (this as any).pendingFacilityContact = facilityContact;
        return;
      } else {
        (this as any).pendingDeleteSpecialty = null;
        (this as any).pendingFacilityContact = null;
      }

      let self = this
      deleteSpecialty.updatingData = true;
      HTTP.delete('/api/facilities/' + deleteSpecialty.facilityId + '/contacts/' + deleteSpecialty.facilityContactId + '/specialties/' + deleteSpecialty.specialtyId)
      .then(function (response) {
        deleteSpecialty.updatingData = false;
        deleteSpecialty.isEditing = false;
        // deleteSpecialty.hasBeenDeleted = true;
        self.getFacilitySpecialtyContacts();
        // Remove this specialty from the specialties list
        // self.removeSpecialtyFromFacilityContact(deleteSpecialty, facilityContact);

        // Broadcast, to whoever is listening, that a new Facility Contact Specialty has been saved
        facilityEventHub.$emit('SPECIALTY_CONTACT_CHANGE');

        self.$notify({
          group: 'main',
          type: 'success',
          title: 'Successfully Deleted',
          text: 'Successfully deleted Facility Contact Specialty.',
          // duration: 5000
        });
      })
      .catch(function (error) {
        console.log('error');
        console.log(error);
        deleteSpecialty.updatingData = false;
        let generalError = getRestResponseErrorMessage(error);
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error Deleting',
          text: generalError ? generalError : 'An error occurred deleting facility contact specialty.',
          // duration: 5000
        });
      })
    },

    toggleEditFacilitySpecialtyContact (facilitySpecialtyContact: any) {
      let selectedFacilitySpecialtyContactId = facilitySpecialtyContact.id;
      // Collapse any editing facilitySpecialtyContacts
      // Delete any existing "new" facilitySpecialtyContacts
      let indexesToDelete: any = [];
      this.facilitySpecialtyContacts.forEach(function (facilitySpecialtyContact: any, index: any) {
        if (facilitySpecialtyContact.isNew) {
          indexesToDelete.push(index);
        }
        if (selectedFacilitySpecialtyContactId !== facilitySpecialtyContact.id) {
          facilitySpecialtyContact.isEditing = false;
        }
      });
      let self = this;
      indexesToDelete.forEach(function (indx: number) {
        self.facilitySpecialtyContacts.splice(indx,1);
      })
      facilitySpecialtyContact.isEditing = !facilitySpecialtyContact.isEditing;
    },
    // addFacilitySpecialtyContact () {
    //   // Collapse any editing facilitySpecialtyContacts
    //   // Delete any existing "new" facilitySpecialtyContacts
    //   let indexesToDelete: any = [];
    //   this.facilitySpecialtyContacts.forEach(function (facilitySpecialtyContact, index) {
    //     if (facilitySpecialtyContact.isNew) {
    //       indexesToDelete.push(index);
    //     }
    //     facilitySpecialtyContact.isEditing = false;
    //   });
    //   let self = this;
    //   indexesToDelete.forEach(function (indx: number) {
    //     self.facilitySpecialtyContacts.splice(indx,1);
    //   })

    //   let newFacilitySpecialtyContact = {
    //     id: -1,
    //     isAvailable: true,
    //     isAvailableString: "true",
    //     startDate: new Date(),
    //     endDate: new Date(),
    //     note: '',
    //     isEditing: true,
    //     isNew: true,
    //     updatingData: false
    //   };

    //   this.facilitySpecialtyContacts.unshift(newFacilitySpecialtyContact);
    // },
    cancel (facilitySpecialtyContact: any) {
      facilitySpecialtyContact.isEditing = false;
      if (facilitySpecialtyContact.isNew) {
        // Allow the editing UI to collapse before removing it from the array.
        let self = this;
        setTimeout(function () {
          self.facilitySpecialtyContacts.shift();
        }, 300);
      } else {
        this.getFacilitySpecialtyContacts();
      }
    },
    onCopy (param: any) {
      this.$notify({
        group: 'main',
        type: 'success',
        title: 'Successfully Copied',
        text: 'Text ' + param.text + ' has been copied.',
        // duration: 5000
      });
    },
    onError (param: any) {
      console.log('Error!');
      console.log(param);
      this.$notify({
        group: 'main',
        type: 'error',
        title: 'Error Copying',
        text: 'Something went wrong copying to your clipboard.',
        // duration: 5000
      });
    },
  }
})



// WEBPACK FOOTER //
// ./src/components/facility/cards/facilitySpecialtyContacts/FacilitySpecialtyContactsCard.ts